/**
 * Module dependencies.
 */

import { LastLineProps } from 'app/components/organisms/crud/form-types';
import { formatCurrency } from 'app/core/utils/formatter';
import BigNumber from 'bignumber.js';
import { reduce } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'app/components/organisms/field/field';

/**
 * Export `TableFooter` component.
 */

export function TableFooter({ data }: LastLineProps): JSX.Element {
  const [translate] = useTranslation();
  const total = useMemo(() => {
    return reduce(
      data,
      (acc: any, item) => {
        acc.total = acc.total.plus(item.amount ?? '0');
        acc.totalWithTax = acc.totalWithTax.plus(item.total ?? '0');

        if (item.paid) {
          acc.totalPaid = acc.totalPaid.plus(item.total ?? '0');
        }

        return { ...acc };
      },
      {
        total: new BigNumber('0'),
        totalWithTax: new BigNumber('0'),
        totalPaid: new BigNumber('0')
      }
    );
  }, [data]);

  return (
    <div
      className={
        'contents max-[600px]:flex max-[600px]:flex-col max-[600px]:rounded-lg max-[600px]:overflow-hidden max-[600px]:shadow-[0px_0px_5px_0px_rgba(0,0,0,0.30)] max-[600px]:mb-4 max-[600px]:p-4 max-[600px]:bg-[#f2f2f2]'
      }
    >
      <div className={'col-[8/12] pt-10 pr-[50px]'}>
        <Field title={translate('common.labels.items')} value={String(data?.length)} />

        {Object.keys(total).map(key => {
          return <Field key={key} title={translate(`common.labels.${key}`)} value={formatCurrency(total[key])} />;
        })}

        <Field
          title={translate('common.labels.totalTAX')}
          value={formatCurrency(total.totalWithTax.minus(total.total))}
        />

        <Field
          title={translate('common.labels.inDebt')}
          value={formatCurrency(total.totalWithTax.minus(total.totalPaid))}
        />
      </div>
    </div>
  );
}
